import { render, staticRenderFns } from "./Block1.vue?vue&type=template&id=6766d24e&"
import script from "./Block1.vue?vue&type=script&lang=js&"
export * from "./Block1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports